/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-01-19 17:49:18
 * @LastEditors: your name
 * @Description: 重点车辆
 */
import request from "@/utils/request.js";

// 套牌车查询
export const fakeplateQuery = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/fakeplate",
    data: data || {},
    method: "post"
  });
};

// 套牌车详情请求接口
export const fakeplateDetailQuery = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/fakeplate/detailById/",
    params: data,
    method: "get"
  });
};

// 套牌车单一号码请求接口
export const fakeplateUniquenessQuery = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/fakeplate/uniqueness",
    data: data || {},
    method: "post"
  });
};

// 套牌车更新请求接口
export const fakeplateSave = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/fakeplate/save",
    data: data || {},
    method: "post"
  });
};

// 套牌车单一号码清理接口（误报）
export const fakeplateClear = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/fakeplate/uniqueness/clear",
    data: data || {},
    method: "post"
  });
};

//初次入城分析查询
export const firstEnter = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/first-enter",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};


// 落脚点分析列表
export const stopOver = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/stopover",
    data: data || {},
    method: "post"
  });
};

// 获取落脚点详情
export const stopOveDetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/stopover/detail",
    data: data || {},
    method: "post"
  });
};

// 获取同行车列表
export const followings = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/followings",
    data: data || {},
    method: "post"
  });
};

// 获取同行车列表详情
export const followingsDetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/followings/detail",
    data: data || {},
    method: "post"
  });
};

// 获取昼伏夜出列表
export const dayNightOut = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/day-night-out",
    data: data || {},
    method: "post"
  });
};

// 获取昼伏夜出详情
export const dayNightOutDetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/day-night-out/detail",
    data: data || {},
    method: "post"
  });
};

// 获取频繁出没列表
export const frequencyAppear = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/frequency/appear",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};


// 获取频繁出没详情
export const frequencyAppearDetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/frequency/appear/detail",
    data: data || {},
    method: "post"
  });
};

// 获取车辆详情
export const tollgateRecord = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/tollgate/record/",
    params: data,
    method: "get",

  });
};

// 获取车辆详情6.1后
export const propRetrievalDetail = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/viid/vehicle/prop-retrieval/detail",
    data: data,
    method: "POST",
    ...loadingObj
  });
};

// 获取路径策略
export const pathStrategy = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/path_strategy",
    data: data,
    method: "post",

  });
};

// 获取路径策略详情
export const pathStrategyDetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/path_strategy/detail",
    data: data,
    method: "post",

  });
};

// 一车一档
export const archivesInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/archives/info",
    data: data,
    method: "post",
  });
};

// 车辆标签
export const archivesTags = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/archives/tags",
    data: data,
    method: "post",
  });
};

// 车辆历史轨迹
export const historytrack = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/archives/vehicle/historytrack",
    data: data,
    method: "post",
  });
};